/* ═══════════════════════════════════════════════════
   TrackLab v2 — Live Data Polling (Multi-Race)

   Pre-race:  polls odds + scores + best_odds  (10s)
   In-race:   polls status only                (10s)
   ═══════════════════════════════════════════════════ */

(function () {
  'use strict';

  var MAX_FAILURES = 10;
  var BACKOFF_THRESHOLD = 5;
  var NORMAL_INTERVAL = 10000;
  var BACKOFF_INTERVAL = 30000;

  TL.polling = {};

  function _oddsLabel(f) { return f === '1/1' ? 'Evens' : f; }

  /**
   * Show "Odds changed from X to Y" on a runner row (latest change only).
   * `prev` is the odds the row showed before this poll; the first fill
   * (empty prev) and unchanged odds are ignored. Also tells the bet box via
   * a `tl:odds-changed` event and remembers the change for the next open.
   */
  TL.polling._noteOddsChange = function (r, prev, next, raceId) {
    if (!prev || !next || prev === next) return;
    var text = 'Odds changed from ' + _oddsLabel(prev) + ' to ' + _oddsLabel(next);
    r.querySelectorAll('.odds-change').forEach(function (n) { n.remove(); });

    var hosts = [];
    var base = r.classList.contains('runner-card') ? r.querySelector('.rc-main') : r.querySelector('.r-info');
    hosts.push(base || r);
    var tp = r.querySelector('.top-pick-panel .tp-odds');
    if (tp) hosts.push(tp);
    hosts.forEach(function (h) {
      var note = document.createElement('span');
      note.className = 'odds-change';
      note.textContent = text;
      note.title = text;
      h.appendChild(note);
    });
    r.querySelectorAll('.rc-bet-main .odds, .top-pick-panel .tpp-odds-val').forEach(function (od) {
      od.title = text;
    });

    var detail = { horse: r.dataset.horse || '', from: prev, to: next, raceId: raceId };
    TL.state.oddsChanges = TL.state.oddsChanges || {};
    TL.state.oddsChanges[raceId + '|' + detail.horse] = detail;
    document.dispatchEvent(new CustomEvent('tl:odds-changed', { detail: detail }));
  };

  /** Add / update / remove the per-runner ".rc-value-tag" for a gated signal.
   *  Wording matches services._EDGE_LABELS. */
  TL.polling._setValueTag = function (card, signal) {
    var label = signal === 'SUPER_VALUE' ? 'Very underrated horse'
      : (signal === 'VALUE' ? 'Underrated horse' : '');
    var holder = card.querySelector('.rc-horse-name');
    if (!holder) return;
    var tag = holder.querySelector('.rc-value-tag');
    if (!label) {
      if (tag) tag.remove();
      return;
    }
    if (!tag) {
      tag = document.createElement('span');
      holder.appendChild(tag);
    }
    tag.className = 'rc-value-tag' + (signal === 'SUPER_VALUE' ? ' super' : '');
    tag.textContent = label;
  };

  /** Update a shared runner card (.runner-card) from a poll entry. */
  TL.polling._updateCard = function (card, match) {
    if (match.tracklab_score !== undefined) {
      var sc = card.querySelector('.rc-score');
      if (sc) {
        sc.textContent = TL.scorePct(match.tracklab_score);
        ['top', 'great', 'good', 'mid', 'low'].forEach(function (t) { sc.classList.remove('s-' + t); });
        sc.classList.add(TL.scoreTierClass(match.tracklab_score));
      }
    }
    if (match.bookmaker_odds) {
      // Bet button(s) plus the top-pick panel's "Odds X/Y" line.
      var label = match.bookmaker_odds === '1/1' ? 'Evens' : match.bookmaker_odds;
      card.querySelectorAll('.rc-bet-main .odds, .top-pick-panel .tpp-odds-val').forEach(function (od) {
        od.textContent = label;
      });
    }
    if (match.bookmaker_odds) card.dataset.odds = match.bookmaker_odds;
    if (match.tracklab_score !== undefined) card.dataset.score = match.tracklab_score;
    // "Less" line follows the displayed odds and score (no value dependence);
    // data-value is still kept in sync for the value box.
    var odds = match.bookmaker_odds || card.dataset.odds || '';
    var parts = odds.split('/');
    var score = match.tracklab_score !== undefined ? match.tracklab_score : card.dataset.score;
    if (TL.betting && TL.betting.lessLine && parts.length === 2) {
      // Same gate as the "Underrated horse" box: gated poll signal if sent,
      // else the value flag the server put on this card.
      var gated = 'value_signal' in match && TL.gateValueSignal
        ? TL.gateValueSignal(Number(score), odds, match.value_signal)
        : null;
      var isValue = gated !== null ? gated !== 'NEUTRAL' : card.dataset.value === '1';
      if (isValue) card.dataset.value = '1'; else delete card.dataset.value;
      if (gated !== null) TL.polling._setValueTag(card, gated);
      card.querySelectorAll('.rc-less-line').forEach(function (ln) {
        TL.betting.renderLessLine(ln, parts[0], parts[1], score);
      });
    }
  };

  /**
   * Refresh the visible detail panel for the currently selected runner
   * after a pre-race poll updates data attributes.
   */
  function _refreshSelectedRunner(runnerEl, raceId) {
    var container = document.getElementById('v2Expanded-' + raceId)
                 || document.getElementById('v2InlineDetail-' + raceId);
    if (!container) return;

    var panel = container.querySelector('.detail-panel');
    if (!panel || panel.classList.contains('empty')) return;

    // Re-populate the entire detail panel with updated data
    TL.runner._populateDetail(runnerEl, raceId);

    // Update bet panel if open
    var betPanel = document.getElementById('v2BetPanel');
    // Leave it alone when the user picked a bookmaker from the Bet button's ▼ list.
    if (betPanel && betPanel.classList.contains('open') && !TL.state.bookiePicked) {
      // The bet button and panel follow the single offer (rows[0] when present).
      var offer = TL.betting.offerFor(runnerEl, TL.betting._rowsFor(runnerEl, raceId));
      var displayOdds = offer.odds;
      var oddsParts = displayOdds.split('/');

      TL.state.betNum = parseInt(oddsParts[0]) || 0;
      TL.state.betDen = parseInt(oddsParts[1]) || 1;

      var bpOdds = document.getElementById('v2bpOdds');
      if (bpOdds) bpOdds.textContent = displayOdds;

      TL.betting._renderPanelButton(offer, runnerEl.dataset.horse || '');

      TL.betting._updateReturn();
    }
  }

  function pollOnce(raceId, eventId) {
    var poller = TL.state.activePollers[raceId];
    if (!poller) return;

    // Once off_dt is locked the race is underway — only poll for status
    var url = '/api/race/' + eventId + '/updates/';
    if (poller.offDtLocked) {
      url += '?status_only=1';
    }

    fetch(url)
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) {
        var p = TL.state.activePollers[raceId];
        if (!p) return;
        var wasBackedOff = p.failures >= BACKOFF_THRESHOLD;
        p.failures = 0;

        if (wasBackedOff) {
          TL.polling.stop(raceId);
          TL.polling.start(raceId, eventId);
          return;
        }

        // Update off_dt — lock per race after first receipt
        if (data.off_dt && !p.offDtLocked) {
          var banner = document.querySelector('.live-banner[data-race-id="' + raceId + '"]');
          if (banner) banner.dataset.offTime = data.off_dt;
          var exp2 = document.getElementById('v2Expanded-' + raceId);
          if (exp2) exp2.dataset.offTime = data.off_dt;
          p.offDtLocked = true;
        }

        // Pre-race: update odds, scores, and best_odds in the DOM
        if (!p.offDtLocked && data.entries) {
          var container = document.getElementById('v2Expanded-' + raceId)
                       || document.getElementById('v2InlineDetail-' + raceId);
          var runners = container ? container.querySelectorAll('.runner, .runner-card') : [];
          runners.forEach(function (r) {
            var name = r.dataset.horse;
            var match = data.entries.find(function (e) { return e.horse_name === name; });
            if (!match) return;

            // Update odds
            if (match.bookmaker_odds) {
              var prevOdds = r.dataset.odds || '';
              r.dataset.odds = match.bookmaker_odds;
              TL.polling._noteOddsChange(r, prevOdds, match.bookmaker_odds, raceId);
            }

            // Update score
            if (match.tracklab_score !== undefined) {
              r.dataset.score = match.tracklab_score;
              // Update visible score in the runner row
              var scoreNum = r.querySelector('.num');
              if (scoreNum) {
                scoreNum.textContent = TL.scorePct(match.tracklab_score);
                ['top', 'great', 'good', 'mid', 'low'].forEach(function (t) {
                  scoreNum.classList.remove('c-' + t);
                });
                scoreNum.classList.add('c-' + TL.scoreTier(match.tracklab_score).tier);
              }
            }

            // Shared race cards (race_runners.html): visible score + Bet odds
            if (r.classList.contains('runner-card')) TL.polling._updateCard(r, match);

            // Update best odds and value signal
            if (match.best_odds_fractional) {
              r.dataset.bestOdds = match.best_odds_fractional;
            } else {
              delete r.dataset.bestOdds;
            }
            if (match.best_odds_bookmaker) {
              r.dataset.bestBookmaker = match.best_odds_bookmaker;
            } else {
              delete r.dataset.bestBookmaker;
            }
            if (match.best_odds_url) {
              r.dataset.bestUrl = match.best_odds_url;
            } else {
              delete r.dataset.bestUrl;
            }
            if (match.best_odds_deeplink) {
              r.dataset.bestDeeplink = '1';
            } else {
              delete r.dataset.bestDeeplink;
            }
            if (match.best_odds_display_name) {
              r.dataset.bestDisplayName = match.best_odds_display_name;
            } else {
              delete r.dataset.bestDisplayName;
            }
            if (Array.isArray(match.all_bookmakers) && match.all_bookmakers.length) {
              r.dataset.allBookmakers = JSON.stringify(match.all_bookmakers);
              var cache = TL.runner._bookmakerCache = TL.runner._bookmakerCache || {};
              if (!cache[raceId]) cache[raceId] = {};
              cache[raceId][name] = match.all_bookmakers;
            } else if ('all_bookmakers' in match) {
              // Server says no compare rows now: drop stale inline copy.
              delete r.dataset.allBookmakers;
              var stale = TL.runner._bookmakerCache && TL.runner._bookmakerCache[raceId];
              if (stale) delete stale[name];
            }
            if (match.value_signal) {
              r.dataset.valueSignal = match.value_signal;
            } else {
              delete r.dataset.valueSignal;
            }

            // Refresh detail panel if this runner is selected
            if (r.classList.contains('sel')) {
              _refreshSelectedRunner(r, raceId);
            }
          });
        }

        // If race resulted, notify schedule module
        if (data.status === 'resulted' && TL.schedule && TL.schedule.handleRaceFinished) {
          TL.schedule.handleRaceFinished(raceId);
        }
      })
      .catch(function () {
        var p = TL.state.activePollers[raceId];
        if (!p) return;
        p.failures++;

        if (p.failures >= MAX_FAILURES) {
          console.warn('[TrackLab] Polling stopped for race ' + raceId + ' after ' + MAX_FAILURES + ' failures');
          TL.polling.stop(raceId);
          return;
        }

        if (p.failures === BACKOFF_THRESHOLD) {
          console.warn('[TrackLab] Polling backed off for race ' + raceId);
          clearInterval(p.timer);
          p.timer = setInterval(function () {
            pollOnce(raceId, eventId);
          }, BACKOFF_INTERVAL);
        }
      });
  }

  TL.polling.start = function (raceId, eventId) {
    if (!eventId) return;

    // Stop existing poller for this race if any
    TL.polling.stop(raceId);

    var poller = {
      eventId: eventId,
      failures: 0,
      offDtLocked: false,
      timer: setInterval(function () {
        pollOnce(raceId, eventId);
      }, NORMAL_INTERVAL),
    };

    TL.state.activePollers[raceId] = poller;
  };

  TL.polling.stop = function (raceId) {
    var p = TL.state.activePollers[raceId];
    if (p) {
      clearInterval(p.timer);
      delete TL.state.activePollers[raceId];
    }
  };

  TL.polling.stopAll = function () {
    Object.keys(TL.state.activePollers).forEach(function (id) {
      TL.polling.stop(id);
    });
  };
})();
